module.exports = __webpack_public_path__ + "img/digital-workflow-home.caaa0cd1.png";